import React, { useContext } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from "@mui/material";
import UserService from "rc-app/services/UserService";
import UserContext from "rc-app/context/UserContext";

// interface AlertDialogProps {
//   // open: boolean;
//   //   onClose: () => void;
//   confirmText?: string;
// }

const AlertDialog = () => {
  const { isUserExist, setIsUserExist } = useContext(UserContext);

  // const [alertOpen, setAlertOpen] = useState(open);
  //   const getColor = (): ButtonProps['color'] => {
  //     switch (severity) {
  //       case 'error': return 'error';
  //       case 'warning': return 'warning';
  //       case 'success': return 'success';
  //       default: return 'primary';
  //     }
  //   };

  return (
    <Dialog
      open={!isUserExist && UserService.hasRole("agent")}
      onClose={() => setIsUserExist((prev: any) => !prev)}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      PaperProps={{
        sx: {
          minWidth: "400px",
          borderRadius: "12px",
        },
      }}
    >
      <DialogTitle
        id="alert-dialog-title"
        sx={{
          fontWeight: "bold",
          fontSize: "1.25rem",
          width: "100%",
          borderTopLeftRadius: "4px",
          borderTopRightRadius: "4px",
          "& .MuiAlert-icon": { alignItems: "center" },
        }}
      >
        Alert
      </DialogTitle>
      <DialogContent dividers>
        <DialogContentText id="alert-dialog-description" component="div">
          Plz!!! connect with your admin.
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={{ padding: 2 }}>
        <Button
          onClick={() => {
            UserService.doLogout();
          }}
          color="inherit"
          variant="outlined"
        >
          logout
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AlertDialog;
